//WPUlike の JS をリロード
export default function () {
	const ulikeProJs = document.getElementById('wp-ulike-pro-js');
	const ulikeJs = document.getElementById('wp_ulike-js');

	if(ulikeJs) {
		const srcPath = ulikeJs.src;
		ulikeJs.remove();
		const addulikeJs = document.createElement("script");
		addulikeJs.setAttribute("id","wp_ulike-js");
		console.log(srcPath);
		addulikeJs.setAttribute("src", srcPath);
		document.querySelector('body').appendChild(addulikeJs);
	} else {
		console.log('wp_ulike-js not found');
	}
	if(ulikeProJs) {
		const srcPath = ulikeProJs.src;
		ulikeProJs.remove();
		const addulikeJs = document.createElement("script");
		addulikeJs.setAttribute("id","wp-ulike-pro-js");
		console.log(srcPath);
		addulikeJs.setAttribute("src", srcPath);
		document.querySelector('body').appendChild(addulikeJs);
	} else {
		console.log('wp-ulike-pro-js not found');
	}
}
